import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="section-container relative z-10 w-full py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-5 whitespace-nowrap">
              {heroData.tagLabel}
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight text-balance">
              {heroData.title}
              <span className="block text-2xl md:text-3xl lg:text-4xl font-body font-medium text-foreground-600 mt-2">
                {heroData.subtitle}
              </span>
            </h1>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 text-balance">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-200 text-foreground-700 rounded-lg font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20composition%20featuring%20an%20elegant%20home%20theater%20setting%20with%20warm%20golden%20and%20deep%20red%20ambient%20lighting%2C%20comfortable%20modern%20seating%2C%20a%20large%20premium%20display%20showing%20abstract%20film%20grain%20texture%20and%20soft%20bokeh%20lights%2C%20cozy%20movie%20night%20atmosphere%20with%20artistic%20editorial%20photography%20style%2C%20warm%20rich%20tones%2C%20dramatic%20yet%20inviting%20mood%2C%20high%20detail&width=1000&height=750&seq=hero-main-visual&orientation=landscape"
                alt="天狼影院 - 高清流畅追剧体验"
                className="w-full h-full object-cover object-top"
                title="天狼影院高清在线观看体验"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}